export default __webpack_public_path__ + "static/media/2_long.d14c4fb2.svg";